import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import { PlusCircle } from 'feather-icons-react/build/IconComponents';
import { useDispatch, useSelector } from 'react-redux';
import AddCategoryList from '../../core/modals/inventory/addcategorylist';
import AddCategory from '../../core/modals/inventory/addcategory';
import EditCategoryList from '../../core/modals/inventory/editcategorylist';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import Table from '../../core/pagination/datatable'
import {set_category_edit, set_category_list, set_page_refresh} from "../../core/redux/action";
import axios from "axios";
import { dateFormatter } from "../../plugins/helper";

const CategoryList = () => {

    const dispatch = useDispatch();
    const dataSource = useSelector((state) => state.category_list);
    const pageRefresh = useSelector((state) => (state.pageRefresh?.categorylist || 0));

    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");
   
    
  useEffect(() => {
    async function fetchData() {
        axios.get('getusercategories/', {}).then((res) => {
            dispatch(set_category_list(res.data))
        })
    }
    fetchData()
  }, [pageRefresh])

    //Permissions  
    const permissions = useSelector(state => state.permissions) || [];
    const roleTitle = useSelector(state => state.roleTitle) || '';
    const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';

    const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'category' && p.Permission.toLowerCase() === 'view');
    const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'category' && p.Permission.toLowerCase() === 'create');
    const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'category' && p.Permission.toLowerCase() === 'update');
    const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'category' && p.Permission.toLowerCase() === 'delete');

    if (!canView) {
        return ( 
        <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{t?.[l]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
    )}
    //

    const columns = [

        {
            title: t?.[l]?.["category"] || "Category",
            dataIndex: "name",
            // sorter: (a, b) => a.category.length - b.category.length,
        },
        {
            title: t?.[l]?.["created_at"] || "Created At",
            dataIndex: "createdAt",
            render: (text) => (
                <span className="">
                    {dateFormatter(text,l)}
                </span>
            ),
            // sorter: (a, b) => a.createdOn.length - b.createdOn.length,
        },
       
        {
            title: t?.[l]?.["action"] || 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                    {canUpdate && (
                        <Link className="me-2 p-2" to="#" data-bs-toggle="modal" data-bs-target="#edit-category"
                        onClick={() => {
                            dispatch(set_category_edit(record));
                        }}
                        >
                            <i data-feather="edit" className="feather-edit" ></i>
                        </Link>
                        )}
                    {canDelete && (
                        <Link className="confirm-text p-2" to="#"  >
                            <i data-feather="trash-2" className="feather-trash-2" onClick={() => {showConfirmationAlert(record)}}></i>
                        </Link>
                        )}
                    </div>
                </td>
            )
        },
    ]
    const MySwal = withReactContent(Swal);

    const showConfirmationAlert = (record) => {
        MySwal.fire({
            title: t?.[l]?.["are_you_sure?"] || "Are you sure?",
            text: t?.[l]?.["you_won't_be_able_to_revert_this!"] || "You won't be able to revert this!",
            showCancelButton: true,
            confirmButtonColor: "#00ff00",
            confirmButtonText: t?.[l]?.["yes,_delete_it!"] || "Yes, delete it!",
            cancelButtonColor: "#ff0000",
            cancelButtonText: t?.[l]?.["cancel"] || "Cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                let result = await axios.post("removecategory/", record);
                console.log(result)
                
                dispatch(set_page_refresh("categorylist"))
                MySwal.fire({
                  title: t?.[l]?.["deleted!"] || "Deleted!",
                  text: t?.[l]?.["item_has_been_deleted."] || "Item has been deleted.",
                  className: "btn btn-success",
                  confirmButtonText: t?.[l]?.["ok"] || "OK",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then(() => {
                });
              } catch(e) {
                console.log(e)
                return false;
              }
              
            } else {
              MySwal.close();
            }

        });
    };
    return (
        <div>
            <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>{t?.[l]?.["category"] || "Category"}</h4>
                                <h6>{t?.[l]?.["manage_your_categories"] || "Manage your categories"}</h6>
                            </div>
                        </div>
                        {canCreate ? (
                        <div className="page-btn">
                            <Link
                                to="#"
                                className="btn btn-added"
                                data-bs-toggle="modal"
                                data-bs-target="#add-category2"
                            >
                                <PlusCircle className="me-2" />
                                {t?.[l]?.["add_new_category"] || "Add New Category"}
                            </Link>
                        </div>
                         ) : null}
                    </div>
                    
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            {/* /Filter */}
                            <div className="table-responsive">
                            <Table columns={columns} dataSource={dataSource} />  
                            </div>
                        </div>
                    </div>
                    {/* /product list */}
                </div>
            </div>
            <AddCategoryList />
            <EditCategoryList />
            <AddCategory />
        </div>
    )
}

export default CategoryList
